(function(angular, _) {
  'use strict';

  var documentsApp = angular.module('onvio.documents');

  documentsApp.config(['$stateProvider', '$urlRouterProvider', 'dmsRoutes', function($stateProvider, $urlRouterProvider, dmsRoutes) {

    $urlRouterProvider.when(dmsRoutes.defaultRoute.from, dmsRoutes.defaultRoute.to);

    $urlRouterProvider.rule(function($injector, $location) {
      //Override all "Drive" routes so that bookmarks still are TECHNICALLY valid.
      var path = $location.path();
      var fixedPath = path.replace('/drive/', '/documents/');
      if (path !== fixedPath) {
        $location.replace().path(fixedPath);
      }

      // Override notification routes for already created approvals and requests
      if (path.startsWith('/documents/requests')) {
        fixedPath = path.replace('/documents/requests/', '/documents/communications/request/');
        $location.replace().path(fixedPath);
      } else if (path.startsWith('/documents/approvals')) {
        fixedPath = path.replace('/documents/approvals/', '/documents/communications/approval/');
        $location.replace().path(fixedPath);
      }
    });

    $stateProvider.state('dmsMain', {
      //url: '/documents',
      templateUrl: 'documents/dms-main.html',
      controller: 'dmsMainCtrl as dmsMain',
      resolve: {
        // Doesn't allow main controller (and by extension sub-state controllers)
        // to load until translations are ready, avoiding glimpses of untranslated strings
        translateReady: ['$translate', function($translate) {
          return $translate.onReady();
        }]
      }
    });

    function dmsMFERouteConfig(stateName, routeUrl, mfeLib) {
      $urlRouterProvider.when(routeUrl, `${routeUrl}/`);
      if (!mfeLib) {
        mfeLib = '@onviobr/dms-scan';
        let isRouteReloading = false;
        let cachedNode;
        $stateProvider.state(stateName, {
          url: `${routeUrl}/{path:.*}`,
          template: `<${stateName}-fake-view-placeholder></${stateName}-fake-view-placeholder>`,
          reloadOnSearch: false,
          controller: ['$state', '$scope', function($state, $scope) {

            this.$onInit = function() {
              if (!cachedNode) {
                cachedNode = document.createElement('mfe-loader');
                cachedNode.setAttribute('module-name', mfeLib);
              } else {
                cachedNode.preventUnmount = isRouteReloading;
                document.querySelector(`${stateName}-fake-view-placeholder`).replaceWith(cachedNode);
                cachedNode.preventUnmount = false;
              }
              isRouteReloading = false;
              cachedNode.removeAllListeners('mfe-route-change');
              cachedNode.addEventListener('mfe-route-change', function(event) {
                if (event.detail.includes('scan') || event.detail.includes('insert-scan') || event.detail.includes('combine')) {
                  isRouteReloading = true;
                  $state.transitionTo(stateName, { path: event.detail.replace(`${routeUrl}/`, '') }, {
                    inherit: true,
                    location: true,
                    reload: false,
                    notify: true,
                  });
                }
              });
            };

            const stopListening = $scope.$on('$destroy', function() {
              cachedNode.preventUnmount = isRouteReloading;
              cachedNode.removeAllListeners('mfe-route-change');
              if (!isRouteReloading) {
                cachedNode = undefined;
              }
              stopListening();
            });
          }],
        });
      } else {
        $stateProvider.state(stateName, {
          url: `${routeUrl}/{path:.*}`,
          template: `<mfe-loader module-name="${mfeLib}" id="dms-app-mfe"></mfe-loader>`,
          controller: ['$rootScope', function($rootScope) {
            this.$onInit = function() {
              document.getElementById('dms-app-mfe').setAttribute('props', `${$rootScope.selectedFilesInfo}`);
            };
          }],

        });
      }
    }

    dmsMFERouteConfig('insert-scan-in-root', '/documents/grid/{drawer:(?:my|MY|My|firm|Firm|FIRM)}/:drawerId/document/:documentId/insert-scan');
    dmsMFERouteConfig('insert-scan-in-container', '/documents/grid/{drawer:(?:client|Client|CLIENT|my|MY|My|firm|Firm|FIRM)}/:drawerId/{containerType:(?:folder|Folder|FOLDER|project|Project|PROJECT|APP_GROUP|YEAR_GROUP)}/:containerId/document/:documentId/insert-scan');
    dmsMFERouteConfig('insert-scan-in-template-root', '/documents/grid/templates/:templateId/folders/document/:documentId/insert-scan');
    dmsMFERouteConfig('insert-scan-in-template-folder', '/documents/grid/templates/:templateId/folders/:folderId/document/:documentId/insert-scan');
    dmsMFERouteConfig('insert-scan-in-document-root', '/documents/{drawer:(?:client|Client|CLIENT|my|MY|My|firm|Firm|FIRM)}/:drawerId/document/:documentId/insert-scan');
    dmsMFERouteConfig('insert-scan-in-document-container', '/documents/{drawer:(?:client|Client|CLIENT|my|MY|My|firm|Firm|FIRM)}/:drawerId/{containerType:(?:folder|Folder|FOLDER|project|Project|PROJECT|APP_GROUP|YEAR_GROUP)}/:containerId/document/:documentId/insert-scan');
    dmsMFERouteConfig('insert-scan-in-template-root-file', '/documents/templates/:templateId/document/:documentId/insert-scan');
    dmsMFERouteConfig('insert-scan-in-template-folders-file', '/documents/templates/:templateId/folders/:folderId/document/:documentId/insert-scan');
    dmsMFERouteConfig('scan-and-upload-in-root', '/documents/{drawer:(?:my|MY|My|firm|Firm|FIRM)}/:drawerId/scan');
    dmsMFERouteConfig('scan-and-upload-in-container', '/documents/{drawer:(?:client|Client|CLIENT|my|MY|My|firm|Firm|FIRM)}/:drawerId/{containerType:(?:folder|Folder|FOLDER|project|Project|PROJECT|APP_GROUP|YEAR_GROUP)}/:containerId/scan');
    dmsMFERouteConfig('scan-and-upload-in-template-root', '/documents/templates/:templateId/folders/scan');
    dmsMFERouteConfig('scan-and-upload-in-template-folder', '/documents/templates/:templateId/folders/:folderId/scan');

    dmsMFERouteConfig('combine-in-root', '/documents/{drawer:(?:my|MY|My|firm|Firm|FIRM)}/:drawerId/combine', '@onviobr/dms-app');
    dmsMFERouteConfig('combine-in-container', '/documents/{drawer:(?:client|Client|CLIENT|my|MY|My|firm|Firm|FIRM)}/:drawerId/{containerType:(?:folder|Folder|FOLDER|project|Project|PROJECT|APP_GROUP|YEAR_GROUP)}/:containerId/combine', '@onviobr/dms-app');
    dmsMFERouteConfig('combine-in-template-root', '/documents/templates/:templateId/folders/combine', '@onviobr/dms-app');
    dmsMFERouteConfig('combine-in-template-folder', '/documents/templates/:templateId/folders/:folderId/combine', '@onviobr/dms-app');

    _.each(dmsRoutes.routes, function(route) {

      //  This is a workaround for https://github.com/angular-translate/angular-translate/issues/855
      if (!route.config.resolve) {
        route.config.resolve = {};
      }

      route.config.parent = 'dmsMain';

      if (!route.config.frp) {
        route.config.frp = [];
      }

      //let's make sure you actually HAVE those frp's.
      //If not, direct to 404.
      route.config.resolve.frpCheck = ['$location', 'bmPermission', 'AuthenticatedSession', function($location, bmPermission, AuthenticatedSession) {
        if (route.config.frp.length === 0) {
          return true;
        }
        return AuthenticatedSession.loadBindings().then(function() {
          return bmPermission.hasEvery(route.config.frp).catch(function() {
            console.error('FRP not found for requested state', route.config.frp);
            $location.path('/notfound');
          });
        });
      }];

      if (route.name === 'requestAdd' || route.name === 'requestEdit') {
        route.config.resolve.bmUser = ['bmUser', function(bmUser) {
          return bmUser.load().then(function() {
            return bmUser;
          });
        }];
      }

      $stateProvider.state(route.name, route.config);
    });
  }])

    .run(['$q', '$rootScope', '$state', '$animate', 'dmsAccess', 'dmsModels',
      'dmsRoutes', 'dmsPermission', 'dmsFolderService', 'dmsProjectService',
      'dmsHideTreeViewService', 'dmsFolderDataService', 'dmsTreeService',
      'folderManager', 'dmsStateChangeHookService',
      function initializeModule($q, $rootScope, $state, $animate, dmsAccess, dmsModels,
        dmsRoutes, dmsPermission, dmsFolderService, dmsProjectService,
        dmsHideTreeViewService, dmsFolderDataService, dmsTreeService,
        folderManager, dmsStateChangeHookService) {
        $rootScope.$on('$stateChangeStart', function(e, toState) {
          $animate.enabled(toState.parent !== 'dmsMain');
        });
        $rootScope.$on('combine-in-root', (event, data) => {
          $rootScope.selectedFilesInfo = JSON.stringify(data);
          $state.go('combine-in-root', $state.params);
        });
        $rootScope.$on('combine-in-container', (event, data) => {
          $rootScope.selectedFilesInfo = JSON.stringify(data);
          $state.go('combine-in-container', $state.params);
        });
        $rootScope.$on('combine-in-template-root', (event, data) => {
          $rootScope.selectedFilesInfo = JSON.stringify(data);
          $state.go('combine-in-template-root', $state.params);
        });
        $rootScope.$on('combine-in-template-folder', (event, data) => {
          $rootScope.selectedFilesInfo = JSON.stringify(data);
          $state.go('combine-in-template-folder', $state.params);
        });
        (function goToDefaultPage() {
          $rootScope.$on('$stateChangeStart', function(event, toState) {
            var toRoute = dmsRoutes.routes.find((route) => route.name === toState.name);
            if (!toRoute) {
              return;
            }
            function goToFolder(folder) {
              $state.go('folderList', { folderId: folder.id });
            }
            function folderByType(type) {
              return function(folder) {
                return folder.type === type;
              };
            }
            /*
             * We need to determine which tab to show when opening documents based on permissions
             * since we do not automatically show the All Documents tab anymore.
             */
            if (toRoute.config.url === '/documents/all') {
              var firmFolderType = 'firmTaxAndAccountingLibrary';
              var myFolderType = 'myTaxAndAccountingLibraries';
              var rootFoldersPromise = folderManager.getAllRootFolders().then(function(result) {
                return result.data;
              });

              var myDocsPromise = rootFoldersPromise.then((folders) => {
                return folders.find(folderByType(myFolderType));
              });
              var firmDocsPromise = rootFoldersPromise.then((folders) => {
                return folders.find(folderByType(firmFolderType));
              });
              $q.all([
                dmsAccess.has('DMS_HideRecentActivity'),
                dmsAccess.has('DMS_HideDocumentActivity'),
                dmsPermission.has('OnvioDrive.ClientDocuments'),
                dmsPermission.has('OnvioDrive.FirmDocuments'),
                dmsPermission.has('OnvioDrive.MyDocuments')
              ]).then(function(result) {
                /*
                 * If DMS_HideRecentActivity is not set and DMS_HideDocumentActivity is set,
                 * then default to the old All Docs page and don't redirect to another page.
                 */
                if (!result[0] && result[1]) {
                  return;
                } else if (result[2]) {
                  // If access to Client Docs, default to Client Docs.
                  dmsHideTreeViewService.hideTreeView().then(function(hideTreeView) {
                    if (hideTreeView) {
                      $state.go('clientRootList');
                    } else {
                      $state.go('TreeView', {
                        drawer: 'client',
                        drawerId: null,
                        containerId: null,
                        containerType: null,
                        document: null,
                        documentId: null
                      });
                    }
                  });
                  return;
                } else if (result[3]) {
                  // If access to firm docs, default to firm docs
                  dmsHideTreeViewService.hideTreeView().then(function(hideTreeView) {
                    if (hideTreeView) {
                      firmDocsPromise.then(goToFolder);
                    } else {
                      firmDocsPromise.then(function(folder) {
                        $state.go('TreeView', {
                          drawer: 'firm',
                          drawerId: folder.id,
                          containerId: null,
                          containerType: null,
                          document: null,
                          documentId: null
                        });
                      });
                    }
                  });
                  return;
                } else if (result[4]) {
                  // If access to my docs, default to my docs
                  dmsHideTreeViewService.hideTreeView().then(function(hideTreeView) {
                    if (hideTreeView) {
                      myDocsPromise.then(goToFolder);
                    } else {
                      myDocsPromise.then(function(folder) {
                        $state.go('TreeView', {
                          drawer: 'my',
                          drawerId: folder.id,
                          containerId: null,
                          containerType: null,
                          document: null,
                          documentId: null
                        });
                      });
                    }
                  });
                  return;
                }
              });
            }
          });
        })();
        (function limitAccessToTreeView() {

          $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
            var toRoute = dmsRoutes.routes.find(function(route) {
              return route.name === toState.name;
            });
            if (!toRoute) {
              return;
            }
            dmsHideTreeViewService.hideTreeView().then(function(hideTreeView) {
              if (hideTreeView) {
                if (toRoute.config.convertToLegacyStatePromise) {
                  event.preventDefault();
                  toRoute.config.convertToLegacyStatePromise($q, toParams, dmsModels, dmsFolderService).then(function(altState) {
                    $state.go(altState.name, altState.params);
                  });
                }
              } else {
                if (toRoute.config.convertToTreeNavStatePromise) {
                  event.preventDefault();
                  toRoute.config.convertToTreeNavStatePromise($q, toParams, dmsModels, dmsProjectService, dmsFolderDataService, dmsTreeService).then(function(altState) {
                    $state.go(altState.name, altState.params);
                  });
                }
              }
            });
          });
        })();

        (function letDocumentViewerSaveChanges() {
          $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            const stateChangeHook = dmsStateChangeHookService.getStateChangeHookIfAvailable(toState, toParams, fromState, fromParams);
            dmsStateChangeHookService.reset();

            if (typeof stateChangeHook === 'function') {
              const hookResult = stateChangeHook();

              if (hookResult.then) {
                event.preventDefault();
                hookResult.then(function() {
                  $state.go(toState.name, toParams);
                });
              } else if (typeof hookResult === 'boolean' && !hookResult) {
                event.preventDefault();
              }
            }
          });
        })();
      }]);
})(window.angular, window._);
